import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "problem", label: "The Problem" },
    { id: "solution", label: "The Solution" },
    { id: "services", label: "Services" },
    { id: "advantage", label: "The Advantage" },
];

const ASSESSMENT = "https://calendly.com/tkriner/30min";

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
                scrolled
                    ? "border-line bg-ink/85 backdrop-blur-md"
                    : "border-transparent bg-transparent"
            }`}
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 sm:px-8">
                <a
                    href="#"
                    data-testid="nav-brand-logo"
                    aria-label="HITL.partners home"
                    onClick={(e) => {
                        e.preventDefault();
                        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
                        else window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                >
                    <Logo />
                </a>

                <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500 xl:block">
                    By Thom Kriner LLC
                </span>

                <nav className="hidden items-center gap-8 lg:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={`#${l.id}`}
                            onClick={scrollToId(l.id)}
                            className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400 transition-colors hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href={ASSESSMENT}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-schedule-assessment-button"
                    className="group inline-flex items-center gap-2 border border-blaze/60 bg-blaze/10 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-blaze transition-all duration-300 hover:bg-blaze hover:text-ink"
                >
                    Schedule Assessment
                    <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
            </div>
        </header>
    );
}
